<web-design-system-modal [headline]="'lombard.confirmation.headline' | transloco" (dismiss)="modal.close()">
  <div class="mb-4">{{ 'lombard.confirmation.body' | transloco }}</div>
  @if (facade.confirmationData$ | async; as confirmationData) {
    @for (doc of confirmationData.docsToConfirm; track doc.id) {
      <div class="row mt-2">
        <div class="col">
          <a class="link-secondary cursor-pointer d-flex" [href]="doc | pdfUri" target="_blank" rel="noopener noreferrer">
            <svg class="icon icon-18 color-primary mr-2">
              <use xlink:href="/assets/img/svgs/svgset.svg#download-redesign-23" />
            </svg>
            {{ doc | postTitle }}
          </a>
        </div>
      </div>
    }
    <div class="row mt-4">
      <div class="col">
        <label class="checkbox">
          <input [disabled]="hasConfirmed" [(ngModel)]="hasCheckedConditions" type="checkbox" class="custom-control-input" />
          <span class="checkmark"></span>
          {{ 'lombard.confirmation.checkbox' | transloco }}
        </label>
      </div>
    </div>
    @if (facade.error$ | async; as error) {
      <div class="row mt-4 mb-2">
        <div class="col text-color-error">
          {{ error }}
        </div>
      </div>
    }
    @if (!hasConfirmed) {
      <div class="row mt-4">
        <div class="col d-flex align-items-center justify-content-end">
          <a class="link-secondary cursor-pointer mr-2" (click)="dismiss()" [class.disabled]="facade.loading$ | async">
            {{ 'lombard.confirmation.dismiss' | transloco }}
          </a>
          <web-design-system-button
            size="small"
            [disabled]="!hasCheckedConditions || (facade.loading$ | async)"
            (click)="hasConfirmed = true"
          >
            {{ 'lombard.confirmation.cta' | transloco }}
          </web-design-system-button>
        </div>
      </div>
    }
    @if (hasCheckedConditions && hasConfirmed) {
      <web-components-transaction-auth [payload]="authorizePayload$ | async" (transactionResult)="handleTransactionAuthorization($event)" />
    }
  }
</web-design-system-modal>
